import { createContext, useContext, useEffect, useState } from "react";
import { OrderTypeContext } from "./orderType.context";
import { sendToKitchen } from "../utils/restaurantOrder";
export const RestOrderContext = createContext({});

export const RestOrderProvider = ({ children }) => {
  const [restOrderContext, setRestOrderContext] = useState({});
  const [orderTotal, setOrderTotal] = useState(0);
  const [tableNumbers, setTableNumber] = useState("");
  const [orderMessage, setOrderMessage] = useState("");
  const { orderTypeContext } = useContext(OrderTypeContext);

  useEffect(() => {
    var orderValue = 0;
    Object.keys(restOrderContext).map((index) => {
      var tempObject = restOrderContext[index];
      var price = tempObject["itemTotal"];
      orderValue = orderValue + price;
      return 0;
    });
    setOrderTotal(orderValue);
  }, [restOrderContext]);
  const sendToKitchenFunction = () => {
    sendToKitchen(
      restOrderContext,
      orderTypeContext,
      orderTotal,
      tableNumbers,
      orderMessage
    );
    setRestOrderContext({});
    setTableNumber("");
    setOrderMessage("");
  };
  const value = {
    restOrderContext,
    setRestOrderContext,
    orderTotal,
    setOrderTotal,
    tableNumbers,
    setTableNumber,
    sendToKitchenFunction,
    orderMessage,
    setOrderMessage,
  };
  return (
    <RestOrderContext.Provider value={value}>
      {children}
    </RestOrderContext.Provider>
  );
};
